
'use strict';
var $ = require('jquery');
require('slick-carousel');
$(function() {
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
      });
      $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: false,
        focusOnSelect: true,
        arrows: false
      });
      $('.slider-for-products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav-products'
      });
      $('.slider-nav-products').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for-products',
        centerMode: false,
        focusOnSelect: true,
        arrows: false
      });
});

